// import { verifyUser, resetPassword } from "../lib/api/user";
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import { useNavigate } from "react-router-dom";

const ForgetPassword: React.FC = () => {
    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isVerified, setIsVerified] = useState(false);

    const validatePassword = (password: string) => {
        const lengthValid = password.length >= 8;
        const hasLetters = /[a-zA-Z]/.test(password);
        const hasNumbers = /[0-9]/.test(password);
        return lengthValid && hasLetters && hasNumbers;
    };

    const handleVerifyUser = async () => {
        try {
            /*
            const isValidUser = await verifyUser(username, email);
            if (isValidUser) {
                setIsVerified(true);
                setMessage("User verified. Please enter a new password.");
            } else {
                setError("Username and email do not match.");
            }*/
        } catch (err) {
            console.error(err);
            setError("Failed to verify user, please try again.");
        }
    };

    const handleResetPassword = async () => {
        if (!validatePassword(newPassword)) {
            setError("Password must be at least 8 characters long and include both letters and numbers.");
            return;
        }

        if (newPassword !== confirmPassword) {
            setError("Passwords do not match.");
            return;
        }

        try {
            //await resetPassword(username, email, newPassword);
            //setMessage("Password reset successfully. Please sign in with your new password.");
            navigate("/SignIn");
        } catch (err) {
            console.error(err);
            setError("Failed to reset password, please try again.");
        }
    };

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="100vh"
            sx={{ bgcolor: "#E9FAFF" }}
        >
            <Typography
                variant="h3"
                color="Primary"
                marginBottom={2}
                sx={{
                    textShadow: `
                    1px 1px 1px rgba(0, 0, 0, 0.1),
                    2px 2px 2px rgba(0, 0, 0, 0.2),
                    3px 3px 3px rgba(0, 0, 0, 0.3)`,
                }}
            >
                <b>Reset Password</b>
            </Typography>
            {message && (
                <Typography color="textPrimary" marginBottom={2}>
                    {message}
                </Typography>
            )}
            {error && (
                <Typography color="error" marginBottom={2}>
                    {error}
                </Typography>
            )}
            <Stack
                sx={{
                    width: "30ch",
                    marginTop: 3,
                }}
            >
                <TextField
                    required
                    label="Username"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    disabled={isVerified}
                />
                <TextField
                    required
                    label="Email"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={isVerified}
                />
                {isVerified && (
                    <>
                        <TextField
                            required
                            label="New Password"
                            variant="outlined"
                            type="password"
                            fullWidth
                            margin="normal"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                        />
                        <TextField
                            required
                            label="Confirm Password"
                            variant="outlined"
                            type="password"
                            fullWidth
                            margin="normal"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                    </>
                )}
            </Stack>
            {!isVerified ? (
                <Button
                    size="medium"
                    variant="contained"
                    color="primary"
                    onClick={handleVerifyUser}
                    sx={{ marginTop: 3 }}
                    disabled={!username || !email}
                >
                    Verify User
                </Button>
            ) : (
                <Button
                    size="medium"
                    variant="contained"
                    color="primary"
                    onClick={handleResetPassword}
                    sx={{ marginTop: 3 }}
                    disabled={!newPassword}
                >
                    Reset Password
                </Button>
            )}
            <Button
                size="large"
                variant="text"
                color="secondary"
                endIcon={<HomeIcon />}
                onClick={() => navigate("/")}
                sx={{ marginTop: 20 }}
            >
                Home
            </Button>
        </Box>
    );
};

export default ForgetPassword;
